import React, { useEffect, useState, useRef } from "react";
import {
  Box,
  Button,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import mainLogo from "../assets/mainLogo.png";
import logo from "../assets/Logo.png";
import { useNavigate } from "react-router-dom";

export default function WelcomePage() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [visible, setVisible] = useState(true);
  const [shoppingItems, setShoppingItems] = useState([]);
  const spawnRef = useRef(null);
const shoppingEmojis = [
  "🛒","🍎","🥖","🥚","🥦","🍯","🧀","🍞","🍇","🍗",
  "🍊","🍋","🍉","🍌","🍍","🥭","🍑","🍒","🍓","🥝",
  "🥔","🥕","🌽","🌶️","🫑","🥒","🧄","🧅","🍆","🥬",
  "🍄","🥜","🌰","🍪","🍫","🍬","🍭","🥧","🍰","🧁",
  "🥯","🥨","🥩","🥓","🍤","🦞","🦀","🐟","🥫","🍱",
  "🍙","🍚","🍛","🍜","🍝","🌭","🍔","🍟","🍕","🥗",
  "🥪","🌮","🌯","🫔","🥟","🍢","🍡","🍧","🍨","🍦",
  "🥤","🧋","☕","🍵","🥛","🍼","🫖","🍺","🍻","🥂",
  "🍷","🥃","🍹","🍸","🧃","🧉","🥄","🍴","🍽️","🧂",
  "🪵","🧊","🥠","🫓","🥥","🫘","🫛","🍠","🥯","🥗",
  "🫒","🥨","🍩","🍮","🍯","🧀","🍏","🥖","🍅","🍋",
  "🍇","🍓","🥑","🍌","🍍","🍑","🍊","🥭","🍒","🥦",
  "🥬","🥒","🌽","🥕","🥔","🍄","🫑","🌶️","🍆","🧅",
  "🧄","🌰","🥜","🍯","🍞","🥯","🥨","🥩","🍖","🍗",
  "🥓","🦴","🍔","🌭","🍟","🍕","🥪","🥙","🌮","🌯",
  "🫔","🥗","🥘","🍲","🍛","🍜","🍝","🍠","🥟","🥠",
  "🥡","🍢","🍣","🍤","🍥","🍡","🥧","🍦","🍧","🍨",
  "🍩","🍪","🎂","🍰","🧁","🥛","☕","🫖","🍵","🥤",
  "🧋","🍺","🍻","🥂","🍷","🥃","🍸","🍹","🧃","🧉"
];

  const navigate = useNavigate();

  useEffect(() => {
    // Spawn shopping items for first 5 seconds then stop
    const startTime = Date.now();
    spawnRef.current = setInterval(() => {
      const now = Date.now();
      if (now - startTime > 5000) {
        clearInterval(spawnRef.current);
        spawnRef.current = null;
        return;
      }
      const id = `${now}-${Math.random().toString(36).slice(2, 7)}`;
      const left = Math.random() * 90 + 2; // percent
      const size = Math.floor(
        isMobile ? 28 + Math.random() * 36 : 36 + Math.random() * 60
      );
      const hue = Math.floor(Math.random() * 360);
      const emoji =
        shoppingEmojis[Math.floor(Math.random() * shoppingEmojis.length)];
      const duration = 8 + Math.random() * 4; // seconds
      const rotate = Math.random() * 30 - 15; // degrees

      setShoppingItems((prev) => [
        ...prev,
        { id, left, size, hue, emoji, duration, rotate },
      ]);

      // Remove after animation ends
      setTimeout(() => {
        setShoppingItems((prev) => prev.filter((b) => b.id !== id));
      }, (duration + 0.5) * 1000);
    }, 400);

    return () => {
      if (spawnRef.current) clearInterval(spawnRef.current);
    };
  }, [isMobile, shoppingEmojis]);

  const handleEnter = () => {
    navigate("/signup");
    localStorage.setItem("endWelcome", "true");
  };

  if (!visible) return null;

  return (
    <Box
      dir="rtl"
      sx={{
        position: "fixed",
        inset: 0,
        zIndex: 1400,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #f5f7fa 0%, #e4edf5 100%)",
        overflow: "hidden",
        px: 2,
      }}
    >
      {/* Component-local CSS for animations */}
      <style>{`
        @keyframes floatUp {
          0% { 
            transform: translateY(0) translateX(0) rotate(0deg); 
            opacity: 1; 
          }
          25% { 
            transform: translateY(-25vh) translateX(8px) rotate(${
              Math.random() * 10
            }deg); 
          }
          50% { 
            transform: translateY(-50vh) translateX(-8px) rotate(${
              Math.random() * -10
            }deg); 
            opacity: 0.9; 
          }
          75% { 
            transform: translateY(-75vh) translateX(8px) rotate(${
              Math.random() * 10
            }deg); 
          }
          100% { 
            transform: translateY(-110vh) translateX(0) rotate(0deg); 
            opacity: 0; 
          }
        }
        
        @keyframes subtlePulse {
          0% { transform: scale(1); }
          50% { transform: scale(1.05); }
          100% { transform: scale(1); }
        }
      `}</style>

      {/* Shopping items floating animation */}
      {shoppingItems.map((item) => (
        <Box
          key={item.id}
          sx={{
            position: "absolute",
            left: `${item.left}%`,
            bottom: -50,
            fontSize: `${item.size}px`,
            animation: `floatUp ${item.duration}s linear forwards`,
            zIndex: 1300,
            textShadow: "0 2px 4px rgba(0,0,0,0.1)",
            opacity: 0.85,
            transform: `rotate(${item.rotate}deg)`,
          }}
          aria-hidden
        >
          {item.emoji}
        </Box>
      ))}

      {/* Hero card with glass effect */}
      <Box
        sx={{
          width: "100%",
          maxWidth: 960,
          borderRadius: 3,
          p: { xs: 3, md: 5 },
          textAlign: "center",
          background: "rgba(255, 255, 255, 0.85)",
          backdropFilter: "blur(10px)",
          boxShadow: "0 20px 60px rgba(2, 6, 23, 0.1)",
          border: "1px solid rgba(255, 255, 255, 0.5)",
          zIndex: 1401,
          animation: "subtlePulse 3s infinite ease-in-out",
        }}
        role="dialog"
        aria-label="Welcome"
      >
        {/* Unified logo container */}
        <Box
          sx={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            alignItems: "center",
            justifyContent: "center",
            gap: { xs: 3, md: 6 },
            mb: { xs: 3, md: 5 },
            flexWrap: "wrap",
          }}
        >
          {/* Main Logo - consistent sizing */}
          <Box
            sx={{
              width: { xs: 180, sm: 220, md: 260 },
              height: { xs: 100, sm: 120, md: 140 },
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: 3,
              overflow: "hidden",
              boxShadow: "0 10px 30px rgba(0, 0, 0, 0.08)",
            }}
          >
            <Box
              component="img"
              src={mainLogo}
              alt="Main Logo"
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
              }}
            />
          </Box>

          {/* Secondary Logo - same height as main logo */}
          <Box
            sx={{
              width: { xs: 180, sm: 220, md: 260 },
              height: { xs: 100, sm: 120, md: 140 },
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: 3,
              overflow: "hidden",
              boxShadow: "0 10px 30px rgba(0, 0, 0, 0.08)",
            }}
          >
            <Box
              component="img"
              src={logo}
              alt="Secondary Logo"
              sx={{
                width: "80%",
                height: "80%",
                objectFit: "contain",
              }}
            />
          </Box>
        </Box>

        {/* Title with gradient text */}
        <Typography
          variant={isMobile ? "h4" : "h3"}
          sx={{
            fontWeight: 900,
            lineHeight: 1.2,
            mb: 2,
            background: "linear-gradient(45deg, #3f51b5, #2196f3)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            letterSpacing: "0.5px",
            textShadow: "0 2px 4px rgba(0,0,0,0.05)",
          }}
        >
          أهلاً بك في موقع منتج اسري
        </Typography>

        {/* Subtitle */}
        <Typography
          variant={isMobile ? "body1" : "h6"}
          sx={{
            color: theme.palette.text.secondary,
            maxWidth: 720,
            mx: "auto",
            mb: 4,
            fontWeight: 500,
            lineHeight: 1.6,
          }}
        >
          سوق يجمع منتجات العائلات المحلية في مكان واحد — ادعم المنتج المحلي
          واستكشف قطعًا مميزة
        </Typography>

        {/* CTA Button with hover animation */}
        <Button
          onClick={handleEnter}
          variant="contained"
          sx={{
            px: { xs: 5, md: 7 },
            py: { xs: 1.5, md: 1.75 },
            borderRadius: "50px",
            fontWeight: 700,
            fontSize: { xs: "1.1rem", md: "1.25rem" },
            letterSpacing: "0.5px",
            background: "linear-gradient(45deg, #FF5722, #FF9800)",
            boxShadow: "0 10px 25px rgba(255, 87, 34, 0.3)",
            color: "#fff",
            transition: "all 0.3s ease",
            "&:hover": {
              transform: "translateY(-3px)",
              boxShadow: "0 15px 30px rgba(255, 87, 34, 0.4)",
              background: "linear-gradient(45deg, #E64A19, #F57C00)",
            },
          }}
        >
          ابدأ التسوق الآن
        </Button>

        {/* Floating product icons at bottom */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mt: 5,
            gap: 2,
            flexWrap: "wrap",
          }}
        >
          {shoppingEmojis.slice(0, 6).map((emoji, index) => (
            <Box
              key={index}
              sx={{
                fontSize: { xs: "1.8rem", md: "2.2rem" },
                animation: `subtlePulse ${
                  2 + index * 0.3
                }s infinite ease-in-out`,
                animationDelay: `${index * 0.2}s`,
                opacity: 0.8,
              }}
            >
              {emoji}
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
